import {Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {ProjectsListItemModel} from '../../../../models/projects-list-item.model';
import {MySortButtonStatesEnum} from '../../../../enums/my-sort-button-states.enum';
import {ModalVisibilityService} from '../../../../services/modal-visibility.service';
import {MyFilterModel} from '../../../../models/my-filter.model';
import {BDCheckboxFilter} from '@brother-apps/brother-dealerapp-shared-lib';
import {ProjectHistoryTableModalComponent} from '../project-history-table-modal/project-history-table-modal.component';
import {DeleteAttentionModalComponent} from '../delete-attention-modal/delete-attention-modal.component';
import {IProjectService} from '../../../../services/project.service.interface';
import {Subscription} from 'rxjs';
import {ProjectsEditModalComponent} from '../../../edit-modal/edit-modal.component';
import {EditModalService} from '../../../../services/edit-modal.service';
import {MyProjectsTableRowActionEnum} from '../../../../enums/my-project-table-row-action.enum';
import {ProjectModel} from '../../../../models/project.model';
import {ProjectIsLockedModalComponent} from '../../../project-is-locked-modal/project-is-locked-modal.component';
import {MyEditDialogStepsEnum} from '../../../../enums/my-edit-dialog-steps.enum';
import {SummaryModalComponent} from '../../../summary-modal/summary-modal.component';
import {MyPriceApprovalModeEnum} from '../../../../enums/my-price-approval-mode.enum';
import {ActivatedRoute, Router} from '@angular/router';
import {ProjectFilterComponent} from '../filter/project-filter.component';
import {QuotesModalComponent} from '../../../quotes-modal/quotes-modal.component';
import {ProjectTablesBase} from '../../project-tables-base';
import {ProjectListOrderByColumnEnum} from 'src/app/modules/projects/enums/project-list-order-by-column.enum';
import {ProjectListOrderDirectionEnum} from 'src/app/modules/projects/enums/project-list-order-direction.enum';
import {ProjectListOrderByModel, ProjectListOrderByParamsModel} from 'src/app/modules/projects/models/project-list-order-by.model';
import {ModalDynamicV3Service} from '../../../../../../shared-modal-dynamic/services/modal-dynamic-v3-service.service';
import {IModalDialogV3} from '../../../../../../shared-modal-dynamic/interfaces/i-modal-dialog-v3';

@Component({
    selector: 'app-filtered-project-table',
    templateUrl: './filtered-project-table.component.html',
    styleUrls: ['./filtered-project-table.component.scss']
})
export class FilteredProjectTableComponent extends ProjectTablesBase implements OnInit, OnChanges, OnDestroy {
    // tslint:disable:max-line-length
    @Input() public projects: ProjectsListItemModel[];
    @Input() public filterChoices: BDCheckboxFilter[];
    @Input() public developId: string;
    @Output() public projectsChangedNotification: EventEmitter<void> = new EventEmitter();
    @Output() public projectListOrderByParams = new EventEmitter<ProjectListOrderByModel>();

    @Output() public statusFilterValuesChanged = new EventEmitter<string[]>();
    private lastMenuActionIsFinished = true;


    private defaultSortingData: { property: string, sortOrder: MySortButtonStatesEnum } = {
        property: 'rolloutStart',
        sortOrder: MySortButtonStatesEnum.ASCENT
    };
    private sortingData: { property: string, sortOrder: MySortButtonStatesEnum } = this.defaultSortingData;

    public filterDialogModel = Object.assign(new MyFilterModel(), {
        choices: [],
        filterValueChanged: false,
        activeFilterValues: <string[]>[],
        isResetBtnActive: false
    } as MyFilterModel);


    public isFilterVisible: boolean;
    private modalsSub: Subscription;


    @ViewChild('filterModal', {static: true}) filterModal: ProjectFilterComponent;

    // define which projects the table is working with
    @Input() public tableProjectFilterFn: Function = (project) => {
        return true;
        // tslint:disable-next-line
    };

    constructor(
        private modalVisibilityService: ModalVisibilityService,
        private modalDynamicV3Service: ModalDynamicV3Service,
        private projectService: IProjectService,
        private editModalService: EditModalService,
        private route: ActivatedRoute,
        private router: Router,
        ) {
        super();
    }

    ngOnInit() {
        this.modalsSub = this.modalVisibilityService.closeProjectListPageModalsRequestAnnounced$.subscribe(_ => {
            if (this.isFilterVisible) {
                this.closeFilterOnScroll();
            }
        });
        // this.onFilterModalBtnClicked('RESET_FILTER');
        this.filterDialogModel.resetAll();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.filterDialogModel.choices = this.filterChoices;
        this.filterDialogModel.refreshFilterBtnStates();
    }

    // table buttons  =============

    public onTableSortBtnClicked($event: { columnId: string; state: MySortButtonStatesEnum }) {
        this.modalVisibilityService.announceCloseProjectsListPageModalsRequest();

        if ($event.state === MySortButtonStatesEnum.DISABLED) {
            this.sortingData = null;
        } else {
            // $event.columnId contains property name to sort by, lets use it to initialize sortingData:
            this.sortingData = {property: $event.columnId, sortOrder: $event.state};
        }
        this.sortTable();
    }


    private sortTable() {


        if (this.sortingData) {
            console.log('this.sortingData.property', this.sortingData);
        }

        if (!this.projects) {
            return;
        }

        if (!this.sortingData) {
            // default/initial order will be used
            this.sortingData = {property: 'rolloutStart', sortOrder: MySortButtonStatesEnum.ASCENT};
        }

        if (this.sortingData) {
            let orderByColumn = ProjectListOrderByColumnEnum.ROLLOUT_START;
            let orderByDirection = ProjectListOrderDirectionEnum.ASC;


            const orderByColumnMerge = ProjectListOrderByColumnEnum.ROLLOUT_START;
            const orderByDirectionMerge = ProjectListOrderDirectionEnum.ASC;

            const orderByParamMerge = new ProjectListOrderByParamsModel();
            const orderBySettings = new ProjectListOrderByModel();
            const orderByParam = new ProjectListOrderByParamsModel();
            orderBySettings.orderBy = [];
            switch (this.sortingData.sortOrder) {
                case 2:
                    orderByDirection = ProjectListOrderDirectionEnum.ASC;
                    break;
                case 1:
                    orderByDirection = ProjectListOrderDirectionEnum.DESC;
                    break;

            }


            switch (this.sortingData.property) {

                case 'rolloutStart':
                    orderByColumn = ProjectListOrderByColumnEnum.ROLLOUT_START;
                    break;

                case 'validityOfQuotation':
                    orderByColumn = ProjectListOrderByColumnEnum.VALIDITY_OF_QUOTATION;
                    break;
                case 'companyZip':
                    orderByColumn = ProjectListOrderByColumnEnum.COMPANY_ZIP;
                    break;
                case 'name':
                    orderByColumn = ProjectListOrderByColumnEnum.NAME;
                    break;
                case 'requestedProductsTotalCount':
                    orderByColumn = ProjectListOrderByColumnEnum.REQUESTED_PRODUCTS_TOTAL_COUNT;
                    break;
                case 'status':
                    orderByColumn = ProjectListOrderByColumnEnum.STATUS;
                    break;
                default:
                    console.warn('unexpected column name:', this.sortingData.property);
            }


            orderByParam.column = orderByColumn;
            orderByParam.direction = orderByDirection;
            orderBySettings.orderBy.push(orderByParam);


            this.sortingData = null;
            this.projectListOrderByParams.emit(orderBySettings);


        }

        // this.sortTableBySortingData(this.filteredProjects, this.sortingData);

    }


    public onFilterModalBtnClicked(action: 'ACTIVATE_FILTER' | 'RESET_FILTER') {
        // console.log('onFilterModalBtnClicked', action);

        this.isFilterVisible = false;

        if (action === 'RESET_FILTER') {
            this.filterDialogModel.resetAll();
        }

        if (action === 'ACTIVATE_FILTER') {
            this.filterDialogModel.copyChoicesToValues();
        }
        this.statusFilterValuesChanged.emit(this.filterDialogModel.activeFilterValues);
    }

    public onOpenFilterModalBtnClicked() {
        const filterIsVisibleSaved: boolean = this.isFilterVisible;
        this.modalVisibilityService.announceCloseProjectsListPageModalsRequest();
        this.isFilterVisible = !filterIsVisibleSaved;
    }

    public async onProjectTableRowActionsMenuClicked(model: {
        projectsListItem: ProjectsListItemModel;
        actionId: MyProjectsTableRowActionEnum
    }): Promise<void> {
        // PPU_log console.log(' filteredProjectTableComponent - onProjectTableRowActionsMenuClicked ' );

        this.modalVisibilityService.announceCloseProjectsListPageModalsRequest();

        if (this.lastMenuActionIsFinished && !this.editModalService.isDialogOpened) {
            this.lastMenuActionIsFinished = false;

            let dialogRef: IModalDialogV3;
            let project: ProjectModel;

            let correctedActionId = model.actionId;


            // console.log('corrected row action', MyProjectsTableRowActionEnum[correctedActionId]);

            switch (correctedActionId) {

                case MyProjectsTableRowActionEnum.DOWNLOAD_OFFER_PDF:

                    try {
                        const quotes = await this.projectService.getQuotesForProject(model.projectsListItem.id);
                        // console.log('quotes loaded from rest', quotes);

                        const quoteDialogRef = this.modalDynamicV3Service
                            .open(QuotesModalComponent, {
                                model: {quotes: quotes}
                            });
                        quoteDialogRef.subscribe(async (val) => {
                            // console.log('quoteDialogRef val', val);
                            // currently do nothing
                        });

                    } catch (e) {
                        console.error('unexpected error occurred', e);
                    }
                    break;


                case MyProjectsTableRowActionEnum.PROJECT_NAME_LINK_CLICKED:
                case MyProjectsTableRowActionEnum.EDIT_SUMMARY_PAGE:
                case MyProjectsTableRowActionEnum.EDIT:


                    try {
                        // console.log('waiting for projectService.getProject ....');


                        if ( correctedActionId === MyProjectsTableRowActionEnum.PROJECT_NAME_LINK_CLICKED ) {
                            // open readOnly/preview summary page  (without price approval Info)
                            console.log('project will be opened in PREVIEW mode');
                            project = await this.projectService.getProject(model.projectsListItem.id, false);

                            // actualise status with just loaded value for case when the dialog will be canceled and view will not be refreshed
                            model.projectsListItem.status = project.status;

                            dialogRef = this.modalDynamicV3Service
                                .open(SummaryModalComponent, {
                                    model: {project: project}
                                });
                            dialogRef.subscribe(async (val) => {
                                this.reloadTableContent();
                            });
                        } else {
                            // open project in edit mode
                            // console.log('project will be opened in EDIT mode');
                            // lockProject will be set in getProject automatically according to the active role
                            project = await this.projectService.getProject(model.projectsListItem.id);


                            this.editModalService.updateProjectWidgetContact(project); // should not be awaited

                            let stepToOpenOn: MyEditDialogStepsEnum;
                            switch (model.actionId) {
                                case MyProjectsTableRowActionEnum.EDIT_SUMMARY_PAGE:
                                case MyProjectsTableRowActionEnum.PROJECT_NAME_LINK_CLICKED:
                                    stepToOpenOn = MyEditDialogStepsEnum.STEP6;
                                    break;
                                default:
                                    stepToOpenOn = MyEditDialogStepsEnum.STEP1;
                            }


                            // actualise status with just loaded value for case when the dialog will be canceled and page will not be refreshed
                            model.projectsListItem.status = project.status;

                            // if (this.editModalService.isInternalUser() && model.projectsListItem.priceApprovalStatus === PriceApprovalStatusEnum[PriceApprovalStatusEnum.PRICES_APPROVED]) {
                            //     // this is necessary to be able recognize this state in dialog and save whole project before editing
                            //     if ( project.priceApprovalStatus) {
                            //         console.warn( 'project.priceApprovalStatus already exist, remove workaround', project);
                            //     } else {
                            //         project.priceApprovalStatus = model.projectsListItem.priceApprovalStatus;
                            //         console.warn( 'priceApprovalStatus was copied from projects list, this workaround should be removed after backed will be updated');
                            //     }
                            //
                            // }

                            dialogRef = this.modalDynamicV3Service
                                .open(ProjectsEditModalComponent, {
                                    model: {project: project, stepId: stepToOpenOn}
                                });
                            dialogRef.subscribe(async (val) => {
                                await this.editModalService.handleEditModalResult(val, dialogRef);
                                this.reloadTableContent();

                                // const requestedAction = val['requestedAction'];
                                // if ( requestedAction ===  MyEditModalCloseActionTypeEnum.UNLOCK_PROJECT_LIST_ITEM ) {
                                //     console.log(this.projects);
                                // } else {
                                //     await this.editModalService.handleEditModalResult(val, dialogRef);
                                //     this.reloadTableContent();
                                // }
                            });
                        }

                    } catch (e) {

                        if (e.status === 500) {
                            return;  // do nothing, error message is already shown via interceptor
                        }

                        dialogRef = this.modalDynamicV3Service
                            .open(ProjectIsLockedModalComponent, {
                                model: {
                                    ...this.editModalService.translateAndTransformToErrMessageObj(e)
                                }
                            });
                        // project is locked, so table will be reloaded, or  ...
                        // only current row lock status can be updated to avoid loosing current row focus
                        this.reloadTableContent();
                        console.error(e);
                    }
                    break;


                case MyProjectsTableRowActionEnum.COPY:
                    await this.projectService.copyProject(model.projectsListItem.id);
                    await this.reloadTableContent();
                    break;

                case MyProjectsTableRowActionEnum.HISTORY:
                    dialogRef = this.modalDynamicV3Service.open(
                        ProjectHistoryTableModalComponent, {
                            model: {projectId: model.projectsListItem.id}
                        });
                    break;

                case MyProjectsTableRowActionEnum.DELETE:

                    dialogRef = this.modalDynamicV3Service.open(DeleteAttentionModalComponent);
                    dialogRef.subscribe(async (val: { dialogConfirmed: boolean, msg: string }) => {

                        if (val.dialogConfirmed) {
                            try {
                                await this.projectService.removeProject(model.projectsListItem.id);
                                // this.refreshFilteredProjects();
                            } catch (e) {
                                console.error(e);
                                return;
                            }
                            this.reloadTableContent();
                        }
                    });

                    break;
                case MyProjectsTableRowActionEnum.PRICE_APPROVAL:
                    // console.log('PRICE_APPROVAL');



                    try {
                        project = await this.projectService.getProject(model.projectsListItem.id);

                        let PriceApprovalMode = MyPriceApprovalModeEnum.DISABLED;

                        dialogRef = this.modalDynamicV3Service
                            .open(SummaryModalComponent, {
                                model: {
                                    project: project,
                                    usePriceApprovalMode: PriceApprovalMode
                                }
                            });
                        dialogRef.subscribe(async (val) => {
                            // await this.editModalService.handleSummaryModalResult(val, dialogRef);
                            this.reloadTableContent();
                        });

                    } catch (e) {

                        if (e.status === 500) {
                            return;  // do nothing, error message is already shown via interceptor
                        }

                        dialogRef = this.modalDynamicV3Service
                            .open(ProjectIsLockedModalComponent, {
                                model: {
                                    ...this.editModalService.translateAndTransformToErrMessageObj(e)
                                }
                            });

                        // project is locked, so reload full table
                        // or only update current row lock status to avoid loosing current row focus
                        this.reloadTableContent();
                        console.error(e);
                    }
                    break;

                case MyProjectsTableRowActionEnum.TCO_CALCULATION:

                    await this.router.navigate(['projects-tco/data/' + model.projectsListItem.id]);
                    break;
                default:
                    console.error('unexpected actionID ', model.actionId);

            }


            this.lastMenuActionIsFinished = true;
            // console.log('row action finished');
        }
    }


    private reloadTableContent() {
        // console.log('project list table will be reloaded...');
        this.projectsChangedNotification.next();

    }

    private closeFilterOnScroll() {
        this.isFilterVisible = !this.filterModal?.isBottomEdgeVisible();
    }

    public ngOnDestroy(): void {
        this.modalsSub.unsubscribe();
    }


    /**
     * returns true if status filter has some value defined
     */
    public isStatusFilterActive(): boolean {
        return !!this.filterDialogModel?.activeFilterValues?.length;
    }
}
